<app-topo [dadosCertificado]="dadosCertificado" [dadosRegistro]="dadosRegistro"></app-topo>

<app-nome-sistema [nomeSistema]="'REGISTRO'"></app-nome-sistema>

<div *ngIf="permiteRegistro" class="container jumbotron">

  <div class="row">
    <div class="col-lg-12 text-right" style="margin-top: -30px;">
      <app-botao-ajuda [manual]="'manual3_3'" [titleAjuda]="'Ajuda - Novo registro'" [telaConsulta]="true">
      </app-botao-ajuda>
    </div>
  </div>

  <div class="formulario">
    <form [formGroup]="registroForm" #psForm="ngForm">
      <div class="row justify-content-md-left ">
        <div clas="col col-lg-8">

          <p class="titulo">Bem vindo ao Conectividade Social </p>
          <p>Para realizar o registro, basta preencher os campos abaixo e clicar em Confirmar ou clique no link 'Voltar'
            para retorna ao Portal CNS.</p>

        </div>
      </div>
      <script></script>

      <div class="row justify-content-md-left" *ngIf="dadosCertificado !== undefined && dadosCertificado.caepf">
        <div class="col-lg-8">
          <div class="caepfMensagem">
            <p>
              Inscrição CEI é obrigatória. <br />
              Identificamos que seu certificado digital/token conectividade contém uma inscrição CAEPF. <br />
              Para continuar o registro deste certificado no Conectividade Social é necessário informar a inscrição CEI
              vinculada ao seu CAEPF
            </p>
          </div>
          <mat-form-field hintLabel="Max. 12 caracteres" appearance="fill" class="full-width">
            <input matInput placeholder="Informe o número do CEI: " (ngModelChange)="isCEIValido"
              formControlName="nuCeiDigitado" mask="00.000.00000/00" [readonly]="readonlyCaepf">
            <mat-hint align="end">{{nuCeiDigitado.value?.length || 0}}/12</mat-hint>
            <mat-error *ngIf="nuCeiDigitado.hasError('required')">
              Inscrição CEI é obrigatória.
            </mat-error>
          </mat-form-field>
          <small *ngIf="!isCEIValido" class="ceiMensagem">
            Inscrição CEI inválida.
          </small>

        </div>
      </div>
      <div class="row justify-content-md-left">
        <p><br>
          Selecione o perfil que melhor se enquadra a sua empresa:
          <br>
        </p>
      </div>

      <app-seleciona-perfil *ngIf="dadosCertificado" (perfilSelecionadoEvent$)="atualizaPerfil($event)"
        [dadosCert]="dadosCertificado">
      </app-seleciona-perfil>

      <div class="row justify-content-md-left">
        <div class="col-lg-8" *ngIf="mostraCheckContrato">
          <section class="tp-section">
            <mat-checkbox class="example-margin" formControlName="chkContrato" color="primary"
              [disabled]="!isPerfilValido">
              <button class="textoNegrito" mat-button [disabled]="!isPerfilValido" (click)="lerTermo()">Li e concordo
                com todas cláusulas e regras descritos nesse contrato.</button>
            </mat-checkbox>
          </section>
        </div>
      </div>
      <br /><br />

      <div mat-dialog-actions class="row justify-content-md-left botoes">
        <button mat-raised-button class="md-icon-button btnOK" [disabled]="habilitaBtn" *ngIf="mostraBtnRegistrar"
          (click)="registrar()" cdkFocusInitial>
          <img class="img-fluid" src="assets/icons/save_confirm.png" width="16px" /> Confirmar
        </button>

      </div>

      <div id="myDiv" #contrato hidden class="container">
      </div>

    </form>

  </div>

</div>